import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const Refresh: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 24 24" {...props}>
    <path d="M20.9998 10.12H14.2198L16.9598 7.3C14.2298 4.6 9.80976 4.5 7.07976 7.2C4.34976 9.91 4.34976 14.28 7.07976 16.99C9.80976 19.7 14.2298 19.7 16.9598 16.99C18.3198 15.65 18.9998 14.08 18.9998 12.1H20.9998C20.9998 14.08 20.1198 16.65 18.3598 18.39C14.8498 21.87 9.14976 21.87 5.63976 18.39C2.13976 14.92 2.10976 9.28 5.61976 5.81C9.12976 2.34 14.7598 2.34 18.2698 5.81L20.9998 3V10.12Z" />
  </BlueprintIcon>
);
